function initialState() {
  return {
    podcasts: null,

    podcast: {
      subtitle: "",
      image: "",
      keywords: [],
      copyright: "",
      title: "",
      description: "",
      link: "",
      key: "",
      categories: [],
      language: "",
      author: "",
      explicit: false,
      summary: "",
      block: false,
      updated: 0,
      rssFeed: "",
      image_key: "",
      pretty_url: null,
      owner_email: "",
      total_size: 0,
      third_party_content: false,
      owner_name: "",
      show_type: "",
      station_key: "",
      station_name: "",
      published: true,
    },
  }
}

let state = initialState()

export { initialState, state }
